import React from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { useModals } from 'new/hooks/useModals';
import { EditUser } from 'new/components/settings/Members/EditUser';
import { DeactivateUsers } from 'new/components/settings/Members/DeactivateUsers';
import { useCurrentOrg } from 'new/hooks/adapters/useCurrentOrg';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';

export function MemberActions(props: any = {}) {
  const { org_membership_status } = props;
  const user = useCurrentUser();
  const org = useCurrentOrg();
  const { openModal } = useModals();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  if (!user.isAdmin || !props?.id) {
    return null;
  }

  const isOwner = org?.owner != null && props.id === org.owner && props.email === 'admin@nexla.com';
  const open = Boolean(anchorEl);
  const isActiveInOrg = org_membership_status === 'ACTIVE';

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickEdit = () => {
    setAnchorEl(null);
    openModal(EditUser.modalConfig.name, props);
  };

  const onClickDeactivate = () => {
    setAnchorEl(null);
    openModal(DeactivateUsers.modalConfig.name, {
      deactivate: isActiveInOrg,
      members: [props],
    });
  };

  const deactivateAction = isOwner ? (
    <Tooltip title="Org owners cannot be deactivated" placement="left">
      <span>
        <MenuItem disabled>{isActiveInOrg ? 'Deactivate' : 'Activate'}</MenuItem>
      </span>
    </Tooltip>
  ) : (
    <MenuItem onClick={onClickDeactivate}>{isActiveInOrg ? 'Deactivate' : 'Activate'}</MenuItem>
  );

  return (
    <div>
      <IconButton
        id={props.id + '_member_actions'}
        aria-controls={open ? props.id + '_member_actions' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreHoriz />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={onClickEdit}>Edit</MenuItem>
        {deactivateAction}
      </Menu>
    </div>
  );
}
